// @ts-nocheck
/* eslint-disable */
export const arrowRightUpLineIcon = {
  data: `<svg viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.836 7.84518L6.66386 15.0173L5.48535 13.8388L12.6575 6.66667H6.33603V5H15.5027V14.1667H13.836V7.84518Z" fill="currentColor"/></svg>`,
  name: 'arrow-right-up-line' as const,
};
